import React, { useState, useEffect } from 'react'
import { Grid, Typography, Box, Collapse, TextField } from '@mui/material'
import { Checkbox } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import _ from 'lodash'
import { selectTopics } from '../../../reducers/healthshelf_topic'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SettingsIcon from '@mui/icons-material/Settings';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { hsFilterTopic, hsFilterType, hsFilterSearch, selectHSFiltersRaw } from '../../../reducers/healthshelf_filter';


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const FilterComponent = (props) => {
    const dispatch = useDispatch()
    const Topics = useSelector(state => selectTopics(state))
    const filters = useSelector(state => selectHSFiltersRaw(state))
    const [byTopicExpanded, setByTopicExpanded] = useState(false)
    const [search, setSearch] = useState('')

    useEffect(()=>{
        const timeout = setTimeout(()=>  dispatch(hsFilterSearch({ Search: search })),500)
        return ()=> clearTimeout(timeout)
    },[search])

    const handleTopicFilter = (id, value) => {
        dispatch(hsFilterTopic({ id: id, value: value }))
    }

    const handleTypeFilter = (id, value) => {
        dispatch(hsFilterType({ id: id, value: value }))
    }

    const handleSearch = (_search) => {
        setSearch(_search)
       
    }


    const TopicSelect = Topics.map((x, i) => {
        return (
            <Grid item xs={12} sm={6} md={3}>

                <Grid container direction="row" alignItems="center" justifyContent="start">
                    <Grid item xs={2}>
                        <Checkbox
                            checked={filters.Topics.indexOf(x.Id) > -1}
                            onChange={(e) => handleTopicFilter(x.Id, e.target.checked)}
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant="caption">{x.Title}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    })



    const TypeSelect =
        <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('ARTICLE') >= 0}
                            onChange={(e) => handleTypeFilter('ARTICLE', e.target.checked)}
                            icon={<NewspaperIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<NewspaperIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">Articles</Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('HOW TO') >= 0}
                            onChange={(e) => handleTypeFilter('HOW TO', e.target.checked)}
                            icon={<SettingsIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<SettingsIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">How To</Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('SELF CHECK') >= 0}
                            onChange={(e) => handleTypeFilter('SELF CHECK', e.target.checked)}
                            icon={<SelfImprovementIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<SelfImprovementIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">Self Checks</Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('CHALLENGE') >= 0}
                            onChange={(e) => handleTypeFilter('CHALLENGE', e.target.checked)}
                            icon={<EmojiEventsIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<EmojiEventsIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">Challenges</Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('TRACKER') >= 0}
                            onChange={(e) => handleTypeFilter('TRACKER', e.target.checked)}
                            icon={<QueryStatsIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<QueryStatsIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">Trackers</Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3} md={2}>
                <Grid container direction="row" alignItems="center" justifyContent="start" spacing={2}>
                    <Grid item xs={3}>
                        <Checkbox
                            checked={filters.Types.indexOf('RECIPE') >= 0}
                            onChange={(e) => handleTypeFilter('RECIPE', e.target.checked)}
                            icon={<ListAltIcon sx={{ color: "#BBBBBB" }} />}
                            checkedIcon={<ListAltIcon sx={{ color: "#000000" }} />}
                        />
                    </Grid>
                    <Grid item xs={9}><Typography variant="caption">Recipes</Typography></Grid>
                </Grid>
            </Grid>
        </Grid>


    return (
        <Box p={3}>
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body1">Need Help Finding Something?</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        type="text"
                        variant="standard"
                        value={search}
                        placeholder="Search"
                        label="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                    />

                </Grid>
                <Grid item xs={12} sm={4}>

                    <Box onClick={() => setByTopicExpanded(!byTopicExpanded)} >
                        <Grid container direction="row" alignItems="center" justifyContent="start">
                            <Grid item xs={6} sm={3}>
                                <Typography variant="caption">Filter By Topic</Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} alignItems="left">
                                {byTopicExpanded === true ? <ArrowDropUp /> : <ArrowDropDown />}
                            </Grid>
                        </Grid>
                    </Box>

                </Grid>
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center" justifyContent="start">
                        {TypeSelect}
                    </Grid>
                </Grid>


                <Grid item xs={12} sm={12}>
                    <Box p={byTopicExpanded ? 2 : 0} mt={byTopicExpanded ? 0 : -2} >
                        <Collapse in={byTopicExpanded} timeout="auto" unmountOnExit>

                            <Grid container direction="row" alignItems="center" justifyContent="start">
                                {TopicSelect}
                            </Grid>
                        </Collapse>

                    </Box>
                </Grid>

            </Grid>
        </Box >
    )

}

export default FilterComponent